import { IconProps } from "@material-ui/core";

function StepCheck({ color, className }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 17"
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <title>StepCheck</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M8.5 0.5C12.9191 0.5 16.5 4.08086 16.5 8.5C16.5 12.9191 12.9191 16.5 8.5 16.5C4.08086 16.5 0.5 12.9191 0.5 8.5C0.5 4.08086 4.08086 0.5 8.5 0.5ZM8.5 1.5C4.63314 1.5 1.5 4.63314 1.5 8.5C1.5 12.3669 4.63314 15.5 8.5 15.5C12.3669 15.5 15.5 12.3669 15.5 8.5C15.5 4.63314 12.3669 1.5 8.5 1.5ZM5.46726 8.14693C5.66248 7.95162 5.97906 7.95155 6.17437 8.14676L7.93949 9.91106L11.3376 6.02812C11.5195 5.82031 11.8354 5.79928 12.0432 5.98114C12.251 6.163 12.272 6.47888 12.0902 6.68668L8.34016 10.9717C8.14972 11.1893 7.81495 11.2005 7.61043 10.996L5.46743 8.85404C5.27212 8.65882 5.27205 8.34224 5.46726 8.14693Z" fill={color} />
    </svg>
  );
}

export default StepCheck;
